// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2jkDD","resendInfoText":"OnGoingPaymentBox_resendInfoText__3USDJ"};